<template>
  <svg
    class="svg-icon"
    :width="width"
    :height="height"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g :fill="iconColor">
      <component :is="iconType" :currentColor="iconColor" :opacity="opacity" />
    </g>
  </svg>
</template>

<script>
import icons from './icons'
export default {
  name: 'SvgIcon',
  components: {
    ...icons
  },
  props: {
    iconType: {
      type: String,
      default: () => null
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    },
    opacity: {
      type: String,
      default: '1'
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    }
  }
}
</script>

<style scoped></style>
